import React from "react";
import Input from "react-toolbox/lib/input/Input";
import Dropdown from "react-toolbox/lib/dropdown/Dropdown";
import {ValidationContext} from "./ValidatedForm";
import { FieldValueTranslator, NumberFieldValueTranslator } from "./FieldValueTranslator";
import PropTypes from "prop-types";

class InputAdapterComp extends React.Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);

		this.autoTranslator = null;

		//You always get a string back from the Input component, even if the type
		//and value are both a number. So this makes sure the value gets set as
		//a number.
		if (props.translator == null && props.componentProps.type === "number") {
			this.autoTranslator = NumberFieldValueTranslator;
		}
	}

	handleChange(value) {
		const translator = this.props.translator ? this.props.translator : this.autoTranslator;
		const storeValue = translator ? translator.toStorageValue(value) : value;
		this.props.valueChanged(this.props.fieldName, storeValue);
	}

	render() {
		const translator = this.props.translator ? this.props.translator : this.autoTranslator;
		var displayValue = translator ?
			translator.toDisplayValue(this.props.fieldValue) : this.props.fieldValue;

		//NOTE: This has to set the value of the `Input` component to something other than null or undefined.
		//If you set it null first, then set it to something else, React complains that you are changing a uncontrolled
		//component to a controlled component. I don't know why that is.
		displayValue = displayValue != null ? displayValue : "";

		let validationMessageComp = this.props.validationMessage ?
			<p className="formValidationErrorMsg">{this.props.validationMessage}</p> : null;

		const disabled = this.props.disabled ? this.props.disabled : false;
		return (
			<div className="validatedFormInput">
				<Input
					value={displayValue}
					onChange={this.handleChange}
					disabled={disabled}
					{...this.props.componentProps}
				/>
				{validationMessageComp}
				{/* {msgDiv} */}
			</div>

		);
	}
}

const inputPropTypes = {
	fieldName: PropTypes.string,
	validationMessage: PropTypes.string,

	translator: PropTypes.objectOf(FieldValueTranslator),

	disabled: PropTypes.bool,

	componentProps: PropTypes.object
};

InputAdapterComp.propTypes = inputPropTypes;

/*
	Creates an [uncontrolled Input component](https://reactjs.org/docs/uncontrolled-components.html)
	to display and collect data in a `ValidatedForm` component.
	The `fieldName` prop is the name of value that will be stored. It should match the corresponding
	name in the `inititalValues` and `FormValidator` that you pass into the `ValidatedForm`.
	The value displayed comes from the `ValidatedForm`'s `ValidationContext`.
*/
export function InputAdapter(props) {
	return (
		<ValidationContext.Consumer>
			{ formInfo => {
				return <InputAdapterComp
					valueChanged={formInfo.valueChanged}
					fieldValue={formInfo.fieldValues[props.fieldName]}
					validationMessage={formInfo.validationMessages[props.fieldName]}
					disabled={formInfo.disabledStates ? formInfo.disabledStates[props.fieldName] : null}
					{...props}
				/>;
			}}
		</ValidationContext.Consumer>
	);
}

InputAdapter.propTypes = inputPropTypes;

class DropdownAdapterComp extends React.Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);

	}

	handleChange(value) {
		const storeValue = this.props.translator ? this.props.translator.toStorageValue(value) : value;
		this.props.valueChanged(this.props.fieldName, storeValue);
	}

	render() {
		const displayValue = this.props.translator ?
			this.props.translator.toDisplayValue(this.props.fieldValue) : this.props.fieldValue;


		let validationMessageComp = this.props.validationMessage ?
			<p className="formValidationErrorMsg">{this.props.validationMessage}</p> : null;

		//TODO Remove when React Toolbox is updated
		//Hack fix for [Issue 1870](https://github.com/react-toolbox/react-toolbox/issues/1870) in beta 13.
		const key = Number(new Date());

		return (
			<div className="validatedFormInput">
				<Dropdown
					value={displayValue}
					onChange={this.handleChange}
					key={key}
					{...this.props.componentProps}
				/>
				{validationMessageComp}
			</div>

		);
	}
}

export function DropdownAdapter(props) {
	return (
		<ValidationContext.Consumer>
			{formInfo => {
				return <DropdownAdapterComp
					valueChanged={formInfo.valueChanged}
					fieldValue={formInfo.fieldValues[props.fieldName]}
					validationMessage={formInfo.validationMessages[props.fieldName]}
					{...props}
				/>;
			}}
		</ValidationContext.Consumer>
	);
}


// WEBPACK FOOTER //
// ./src/components/form/FormAdapters.js